// route.js
import { Routes, Route, Navigate } from 'react-router-dom';
import ReportByEvent from "../pages/reportByEvent/ReportByEvent";
import ReportByMix from "../pages/reportByMix/ReportByMix";
import ReportByPurchased from "../pages/reportByPurchased/ReportByPurchased";
import TransactionByDate from "../pages/UserTransaction/ByDate";
import ByVoucher from "../pages/reportByVoucher/ByVoucher";
import InsertResult from "../pages/goalResult";
import UpdateResult from "../pages/recalculation";
import SingleBetByEvent from "../pages/singleBetByEvent/SingleBetByEvent";
import MenuListMobile from "../pages/menuList/MenuListMobile";
import {
  Dashboard, Login, CheckOdd, MatchEvent, DifferentOdd, DiffOddVoucherReport,
  GoalResult, GamblingWinLimit, WinLoseReport, LiveEventControl, Setting, 
  ResultHub, BalanceTransfer, LiveBettingControl, LeagueSelection, BufferZone, UserControl, OddsHub, DashboardV2, VoucherExplorer } from "../pages";

export default function AppRoutes() {
//   const isInvalidPath = !validPaths.includes(location.pathname);

//   if (isInvalidPath) {
//     return <Navigate to="/login" replace />;
//   }

  return (
    <Routes>
      <Route path="*" element={<Navigate to="/login" replace />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard-old" element={<Dashboard />} />
      <Route path="/dashboard" element={<DashboardV2 />} />
        <Route
              path="/check-odd"
              element={<CheckOdd />}
            />
            <Route
              path="/match-event"
              element={<MatchEvent />}
            />
            <Route
              path="/diff-odd"
              element={<DifferentOdd />}
            />
            <Route
              path="/diff-odd-vouchers"
              element={<DiffOddVoucherReport />}
            />
            <Route
              path="/goal-result"
              element={<GoalResult />}
            />
            <Route
              path="/insert-result"
              element={<InsertResult />}
            />
             <Route
              path="/update-result"
              element={<UpdateResult />}
            />
            <Route
              path="/single"
              element={<SingleBetByEvent />}
            />
            <Route
              path="/report-byevent"
              element={<ReportByEvent />}
            />
            <Route
              path="/report-byMix"
              element={<ReportByMix />}
            />
            <Route
              path="/report-bypurchased"
              element={<ReportByPurchased />}
            />
            <Route
              path="/transaction-bydate"
              element={<TransactionByDate />}
            />
            <Route
              path="/by-voucher"
              element={<ByVoucher />}
            />
            <Route
              path="/gambling-limit"
              element={<GamblingWinLimit />}
            />
            <Route
              path="/menu-list"
              element={<MenuListMobile />}
            />
            <Route
            path ="/win-lose"
            element={<WinLoseReport/>}
            />
            <Route
            path = "/live-event-control"
            element={<LiveEventControl/>}
            />
            <Route
            path = "/result-hub"
            element={<ResultHub/>}
            />
            <Route
            path = "/odds-hub"
            element={<OddsHub/>}
            />
            <Route
            path = "/settings"
            element={<Setting/>}
            />
             <Route
            path = "/balance-transfer"
            element={<BalanceTransfer/>}
            />
            <Route
            path = "/live-betting-control"
            element={<LiveBettingControl/>}
            />
            <Route
            path = "/league-selection"
            element={<LeagueSelection/>}
            />
            <Route
            path = "/buffer-zone"
            element={<BufferZone/>}
            />
            <Route
            path = "/user-control"
            element={<UserControl/>}
            />
            <Route
            path="/voucher-explorer"
            element={<VoucherExplorer />}
            />
    </Routes>
  );
}
